const TEXT = {
    MY_CONTENT_TEXT_1:"奖励金",
    MY_CONTENT_TEXT_2:"余额",
    MY_CONTENT_TEXT_3:"下级绑定",
    MY_CONTENT_TEXT_4:"我要充值",
    MY_CONTENT_TEXT_5:"常用银行卡",
    MY_CONTENT_TEXT_6:"我的订单",
    MY_CONTENT_TEXT_7:"下级订单",
    MY_CONTENT_TEXT_8:"我的授权",
    MY_CONTENT_TEXT_9:"设置",
    MY_CONTENT_TEXT_10:"个人信息",
    MY_CONTENT_TEXT_11:"修改密码",
    MY_CONTENT_TEXT_12:"收货地址",
    MY_CONTENT_TEXT_13:"退出登录",
    MY_CONTENT_TEXT_14:"我的授权",
    MY_CONTENT_TEXT_15:"授权号",
    MY_CONTENT_TEXT_16:"代理级别",
    MY_CONTENT_TEXT_17:"关闭",
    MY_CONTENT_TEXT_18:"个人信息",
    MY_CONTENT_TEXT_19:"用户名",
    MY_CONTENT_TEXT_20:"授权品牌",
    MY_CONTENT_TEXT_21:"姓名",
    MY_CONTENT_TEXT_22:"微信号",
    MY_CONTENT_TEXT_23:"手机号",
    MY_CONTENT_TEXT_24:"地址",
    MY_CONTENT_TEXT_25:"修改密码",
    MY_CONTENT_TEXT_26:"旧密码：",
    MY_CONTENT_TEXT_27:"新密码：",
    MY_CONTENT_TEXT_28:"确认新密码：",
    MY_CONTENT_TEXT_29:"确定",
    MY_CONTENT_TEXT_30:"授权证书",
    MY_CONTENT_TEXT_31:"上传头像",
    MY_CONTENT_TEXT_32:"提交",
    MY_CONTENT_TEXT_33:"常用发货快递",
    MY_CONTENT_TEXT_34:"关注商家公众号",
    MY_CONTENT_TEXT_35:"清除缓存",
    messageText: [
        {
          id: "4",
          name: "系统消息"
        },
        {
          id: "5",
          name: "公告咨讯"
        },
        {
          id: "6",
          name: "活动预告"
        }
      ],
     MY_CONTENT_TEXT_36:"去看看",
     eventText : [
      {
        id: "1",
        name: "即将开始"
      },
      {
        id: "2",
        name: "正在进行"
      },
      {
        id: "3",
        name: "已结束"
      }
    ],
    myShopTitle : [
      "近7日销量","近7日营业额","月销量","月营业额"
    ],
    myShopAction : [
      "访客数","总销量","推广","分享"
    ],
    eventAction : [
      "发起推广活动","拼团","秒杀","砍价","取消"
    ],
    eventEditAction : [
      "海报","编辑","复制链接","分享","发起活动","领取奖励"
    ],
};


export {
    TEXT
}


// WEBPACK FOOTER //
// ./src/config/page/cn/my/index.js